// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5538":"77c3c24ed2c96686","56492":"25244269d41c249e"}[chunkId] + ".css";
};